import { makeVar } from '@apollo/client';

const previousPath = makeVar<string>('');
export default previousPath;
